// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1525":"57cb0da95d0342cc","3839":"b0b0a24a446e58bc"}[chunkId] + ".css";
};